import React from 'react';
import {DirectUpload} from 'activestorage';
import {connect} from 'react-redux';
import {DropZone, Spinner, ResourceList, Banner, Icon} from '@shopify/polaris';
import filesize from 'filesize';
import Center from 'components/polaris/react/center';
import {attachFiles, removeFile} from '../../../actions/files';
import Input from './input';
import FileItem from './fileItem';
import railsData from 'utilities/rails-data';

const DIRECT_UPLOAD_URL = railsData('DIRECT_UPLOAD_URL');
const DASHBOARD_FILESIZE_LIMIT = railsData('DASHBOARD_FILESIZE_LIMIT');

class Files extends Input {
  constructor(props) {
    super(props);
    this.state = {
      isUploading: false,
      error: '',
    };
    this.handleOnDrop = this.handleOnDrop.bind(this);
    this.renderItem = this.renderItem.bind(this);
  }

  anyFilesOverLimit(files) {
    return files.some(file => file.size > DASHBOARD_FILESIZE_LIMIT);
  }

  handleOnDrop(files) {
    const {inputId} = this.props;

    if (this.anyFilesOverLimit(files)) {
      return this.setState({
        error: `Please attach files smaller than ${filesize(
          DASHBOARD_FILESIZE_LIMIT
        )}`,
      });
    }

    this.setState({isUploading: true});

    return Promise.all(
      files.map(file => {
        const upload = new DirectUpload(file, DIRECT_UPLOAD_URL);

        return new Promise((resolve, reject) => {
          upload.create((error, blob) => {
            if (error) {
              reject(error);
            } else {
              resolve({
                file,
                signedId: blob.signed_id,
              });
            }
          });
        });
      })
    )
      .then(blobs => {
        this.setState({isUploading: false, error: ''});
        return this.props.attachFiles(inputId, blobs);
      })
      .catch(() => {
        this.setState({
          isUploading: false,
          error:
            'Unexpected system issue. Please try again and contact support if this persists.',
        });
      });
  }

  renderItem(fileObj, itemId) {
    const {inputId} = this.props;

    return (
      <ResourceList.Item media={<Icon color="inkLightest" source="notes" />}>
        <FileItem
          key={itemId}
          inputId={inputId}
          fileObj={fileObj}
          onRemove={this.props.removeFile}
        />
      </ResourceList.Item>
    );
  }

  render() {
    return (
      <div className="sm-workflow-files">
        <DropZone onDrop={this.handleOnDrop}>
          {this.state.isUploading ? (
            <Center>
              <Spinner size="large" color="teal" />
            </Center>
          ) : (
            <DropZone.FileUpload />
          )}
        </DropZone>
        <div className="sm-workflow-files-list">
          {this.state.error ? (
            <Banner status="critical">{this.state.error}</Banner>
          ) : null}
          <ResourceList
            items={this.props.files.reverse()}
            renderItem={this.renderItem}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const {inputId} = ownProps;
  const {files} = state.context;

  return {
    ...Files.mapStateToProps(state, ownProps),
    files: files[inputId] || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...Files.mapDispatchToProps(dispatch),
    attachFiles: (inputId, files) => dispatch(attachFiles(inputId, files)),
    removeFile: (inputId, file) => dispatch(removeFile(inputId, file)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Files);
